import { AxiosResponse } from 'axios';

import {
  IResetData,
  ISignInData,
  ISignUpResponse,
  ISingUpData,
  ITokensResponse,
} from './auth.interface';
import { normalizeEmail } from './normalizeEmail';

import { axiosInstance } from 'services/config';

class AuthApi {
  async signUp(signUpData: ISingUpData): Promise<ISignUpResponse> {
    const response: AxiosResponse<ISignUpResponse> = await axiosInstance.post(
      '/security/signup',
      { ...signUpData, email: normalizeEmail(signUpData.email) },
    );
    return response.data;
  }

  async resendEmail(userEmail: string | null): Promise<void> {
    await axiosInstance.post('/security/confirm/resend', {
      email: userEmail === null ? null : normalizeEmail(userEmail),
    });
  }

  async confirmRegistration(token: string): Promise<void> {
    await axiosInstance.get(`/security/confirm/${token}`);
  }

  async sigIn(signInData: ISignInData): Promise<ITokensResponse> {
    const response: AxiosResponse<ITokensResponse> = await axiosInstance.post(
      '/security/signin',
      { ...signInData, email: normalizeEmail(signInData.email) },
    );
    return {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken,
    };
  }

  async refreshAccountAccessToken(tokens: ITokensResponse): Promise<ITokensResponse> {
    const response: AxiosResponse<ITokensResponse> = await axiosInstance.post(
      '/security/refresh/account',
      tokens,
    );
    return {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken,
    };
  }

  async forgotPassword(email: string): Promise<void> {
    await axiosInstance.post('/security/forgot/password', {
      email: normalizeEmail(email),
    });
  }

  async resetPassword(resetData: IResetData): Promise<void> {
    await axiosInstance.post(`/security/change/password/${resetData.token}`, {
      password: resetData.password,
    });
  }
}

export { AuthApi };
